<template>
	<div class="baseForm">
		<!--<div style="margin:18px 0">-->
		<!--<Breadcrumb :breadcrumb="breadcrumb"/>-->
		<!--</div>-->
		<!--<div style="padding:18px 29px;background: #fff;border-radius:2px;">-->
		<!--<cardTitle title="项目基本信息"/>-->
		<div class="formDom">
			<Form ref="baseFormDom" :dataSource="getBaseForm" id="baseFormDom">
				<template v-slot:unit>
					<!--          <div >-->
					<span
						style="display: inline-block;float:right;margin-top:10px;"
						v-show="checkDisplay('unit')"
					>元</span>
					<!--          </div>-->
				</template>
				<!--        <template v-slot:show>-->
				<!--          <span class="show">查看</span>-->
				<!--        </template>-->
			</Form>
		</div>
		<!--</div>-->
		<!--</div>-->
	</div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb'
// import cardTitle from '@/components/cardTitle'
import Form from '@/components/GlobalForm'
import { forms } from './formData'
import request from '@/utils/request'
export default {
	name: 'Index',
	components: {
		Breadcrumb,
		// cardTitle,
		Form
	},
	props: {
		initData: {
			// 父组件传过来的表单默认值
			type: Object,
			default: () => {
				return {}
			}
		},
		checkDisabled: {
			type: Function,
			default: () => { }
		},
		checkDisplay: {
			type: Function,
			default: () => { }
		},
		pageType: {
			type: String,
			default: () => ''
		},
		quTreeData: {
			type: Array,
			default: () => []
		},
		processConfigType: {
			type: String,
			default: () => ''
		}
	},
	data() {
		return {

		}
	},
	computed: {
		params() {
			return {
				checkDisabled: this.checkDisabled || (() => { }),
				checkDisplay: this.checkDisplay || (() => { }),
				checkFund: this.checkFund
			}
		},
		getBaseForm() {
			console.log('initData的值:', this.initData)
			// 获取formData
			return forms.getBaseForm(this._.cloneDeep(this.initData), this.params, this.pageType, this.quTreeData, this.processConfigType, this, this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {})
		}
	},
	methods: {
		// // 数字输入框
		// numberChange (value) {
		//   let newValue = value
		//   newValue = newValue.replace(/[^\d.]/g, '')// 清除“数字”和“.”以外的字符
		//   newValue = newValue.replace(/^\./g, '')// 验证第一个字符是数字而不是.
		//   newValue = newValue.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的.
		//   newValue = newValue.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		//   setTimeout(() => {
		//     this.$refs.baseFormDom.setFieldsValue('num', newValue)
		//   }, 0)
		// },
		// 开展区域onchange事件
		kaizhanquyuOnChange(value) {
			// alert(JSON.stringify(value))
			// 根据区id获取  区名称对象
			request({
				url: `/auth/online/getDistrictDefaultUsers`,
				method: 'get',
				params: {
					municipalTreeIds: value.join()
				}
			}).then((ret) => {
				this.$emit('kaizhanquyuChangeOk', ret)
			})
		},
		getValue(params) {
			// 获取数据
			const data = this.$refs.baseFormDom.getFieldsValue(params)
			return data
		},
		onSubmit(params) {
			// 校验并获取数据
			const data = this.$refs.baseFormDom.handleSubmit(params)
			return data
		},
		// 获取项目发起方
		getXiangmufaqifang() {
			var userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
			return userInfo.municipal_tree_name
		},
		checkFund(value) {
			let newValue = value
			newValue = newValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
			newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
			newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
			newValue = newValue
				.replace('.', '$#$')
				.replace(/\./g, '')
				.replace('$#$', '.')
			setTimeout(() => {
				this.$refs.baseFormDom.setFieldsValue('project_funding', newValue)
			}, 0)
		}
	}
}
</script>

<style scoped lang="less">
.formDom {
	.show {
		color: #3d73dd;
		cursor: pointer;
	}
	.show:hover {
		color: #4d86ff;
	}
}
</style>
